<template>
    <v-select
      prepend-inner-icon="calendar_today"
      :items="items"
      :item-value="'value'"
      :item-text="'title'"
      v-model="orderState"
      label="Tipo de fecha"
      color="secondary"
      item-color="secondary"
      :hide-details="hideDetails"
      :solo="solo"
      :clearable="clearable"
  ></v-select>
</template>

<script>
export default {
    name: "OrderStateAutocomplete",
    props: {
        value: {type: [String, Array]},
        hideDetails: {type: Boolean, default: false},
        solo: {type: Boolean, default: false},
        clearable: {type: Boolean, default: false},
        isRequired:  {type: Boolean, default: true},
    },
    data: () => ({
        items: [
            {value: "CREATED", title: "Fecha de creación"},
            {value: "DELIVERED", title: "Fecha de entrega"},
            {value: "PAID", title: "Fecha de pago"},
        ]
    }),
    computed: {
        orderState: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    }
}
</script>
